module.exports = __webpack_public_path__ + "media/backgrounds/mohamed-nohassi-jivFqUh9W1g-unsplash-3ad9f186.jpg";